import store from '@/store/store';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import LoadingController from './LoadingController';
import { AxiosError, AxiosResponse } from 'axios';

export interface Vinculo {
  NRVINCULOM: string;
  NMVINCULOM: string;
}

export interface ApuracaoWarning {
  message: string;
  nome: string;
  type: string;
}

export enum Operacao {
  Apuracao,
  Retrocesso
}

class ApuracaoController {
  public static isSetToForceStopOperacao = false;

  private static vinculosOperacaoCount = 0;
  private static vinculosProcessados = 0;

  private static lastOperacaoWarnings: ApuracaoWarning[] = [];

  private static operacao: Operacao;

  private static descriptions = {
    [Operacao.Apuracao]: {
      nameText: 'apuração',
      operationsAlreadyFinishedText: 'apurados',
    },
    [Operacao.Retrocesso]: {
      nameText: 'retrocesso',
      operationsAlreadyFinishedText: 'retrocedidos',
    },
  }

  public static async apurarPeriodo(vinculos: Vinculo[], nrPeriodo: number) {
    this.setOperacaoApuracao();

    if (vinculos.length == 1) {
      this.resetWarningsLastOperacao();
      await this.requestApuracaoPeriodo(vinculos[0], nrPeriodo);
      return;
    }

    await this.apuraEmMassa(vinculos, nrPeriodo, this.requestApuracaoPeriodo);
  }

  public static async retrocederPeriodo(vinculos: Vinculo[], nrPeriodo: number) {
    this.setOperacaoRetrocesso();

    if (vinculos.length == 1) {
      this.resetWarningsLastOperacao();
      await this.requestRetrocessoPeriodo(vinculos[0], nrPeriodo);
      return;
    }

    await this.apuraEmMassa(vinculos, nrPeriodo, this.requestRetrocessoPeriodo);
  }

  private static async apuraEmMassa(vinculos: Vinculo[], nrPeriodo: number, request: (vinculo: Vinculo, nrPeriodo: number) => Promise<void>) {
    ApuracaoController.vinculosOperacaoCount = vinculos.length;
    ApuracaoController.vinculosProcessados = 0;
    ApuracaoController.resetWarningsLastOperacao();
    const descriptions = ApuracaoController.getDescriptions();

    LoadingController.setProgressLoading();
    LoadingController.setLoadingCancelVisible();
    LoadingController.setLoadingAppendedText(`Iniciando ${descriptions.nameText}...`);

    ApuracaoController.unsetForceStopOperacao();

    for (const vinculo of vinculos) {
      await request(vinculo, nrPeriodo);
      ApuracaoController.vinculosProcessados++;
      LoadingController.updateProgressLoading(ApuracaoController.vinculosProcessados / ApuracaoController.vinculosOperacaoCount * 100);
      LoadingController.setLoadingAppendedText(
        `${ApuracaoController.vinculosProcessados} de ${ApuracaoController.vinculosOperacaoCount} já ${descriptions.operationsAlreadyFinishedText}`
      );

      if (ApuracaoController.isSetToForceStopOperacao) {
        break;
      }
    }

    LoadingController.setDefaultLoadingBehavior();
  }

  private static async requestApuracaoPeriodo(vinculo: Vinculo, nrPeriodo: number) {
    const params = {
      requestType: 'Row',
      row: {
        NRORG: store.getters.user.nrorg,
        NRVINCULOM: vinculo.NRVINCULOM,
        NRPERIODOAPURACAO: nrPeriodo,
      },
    };

    const route = 'apurarPeriodo';
    try {
      const response = await HttpRequest.post(route, params);
      
      if (response.data.dataset && response.data.dataset.data.info.length > 0) {
        const alerts = response.data.dataset.data.info.forEach((item) => {
          const info = {
            message: item.TEXTO,
            nome: vinculo.NMVINCULOM,
            type: 'warning'
          };

          ApuracaoController.lastOperacaoWarnings.push(info);
        });
      }
    } catch (e) {
      const message = (e as any).response ? ((e as AxiosError).response.data.error) : (e as string);
      ApuracaoController.lastOperacaoWarnings.push({
        message,
        nome: vinculo.NMVINCULOM,
        type: 'error'
      });
    }
  }

  private static async requestRetrocessoPeriodo(vinculo: Vinculo, nrPeriodo: number) {
    const params = {
      requestType: 'Row',
      row: {
        NRORG: store.getters.user.nrorg,
        NRVINCULOM: vinculo.NRVINCULOM,
        NRPERIODOAPURACAO: nrPeriodo,
      },
    };

    const route = 'retrocederApuracaoPeriodo';

    try {
      await HttpRequest.post(route, params);
    } catch (e) {
      const message = (e as any).response ? ((e as AxiosError).response.data.error) : 'Houve um erro ao retroceder a apuração.';
      ApuracaoController.lastOperacaoWarnings.push({
        message,
        nome: vinculo.NMVINCULOM,
        type: 'error'
      });
    }
  }

  public static forceStopOperacao() {
    ApuracaoController.isSetToForceStopOperacao = true;
  }

  public static unsetForceStopOperacao() {
    ApuracaoController.isSetToForceStopOperacao = false;
  }

  public static hasWarningsLastOperacao() {
    return ApuracaoController.lastOperacaoWarnings.length > 0;
  }

  public static getWarningsLastOperacao() {
    return ApuracaoController.lastOperacaoWarnings;
  }

  public static getLastOperacao() {
    return this.operacao;
  }

  public static resetWarningsLastOperacao() {
    ApuracaoController.lastOperacaoWarnings = [];
  }

  public static setOperacaoApuracao() {
    this.operacao = Operacao.Apuracao;
  }

  public static setOperacaoRetrocesso() {
    this.operacao = Operacao.Retrocesso;
  }

  public static getDescriptions() {
    return this.descriptions[this.operacao];
  }
}

export default ApuracaoController;
